import BrandPartnershipList from "../components/BrandPartnershipList";

const ListBrandPartnershipPage = () => {
  return (
    <BrandPartnershipList />
  );
};

export default ListBrandPartnershipPage;
